import { GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid';

function TableToolbar({ children }) {
  return (
    <GridToolbarContainer
      sx={{
        padding: '10px',
        justifyContent: 'space-between',
      }}>
      <GridToolbarQuickFilter
        sx={{
          marginLeft: '10px',
        }}
      />
      {children}
    </GridToolbarContainer>
  );
}

export default TableToolbar;
